import styled from 'styled-components';

import { Tag } from '@gympass/yoga';

export const Container = styled(Tag.Informative)`
  display: flex;
  flex-direction: row;
  justify-content: start;
  background-color: ${({ theme }) => `${theme.yoga.colors.primaryExtraLight}`};
  padding: ${({ theme }) => theme.yoga.spacing.small}px;
  margin-top: ${({ theme }) => theme.yoga.spacing.xsmall}px;
`;
